export function composeDecorators(editor, ...decoratorFactories) {
  const decorators = decoratorFactories.map((factory) => factory(editor));
  return (entry) => {
    return decorators.flatMap((decorator) => {
      if (typeof decorator === 'function') {
        return decorator(entry) || [];
      }
      return [];
    });
  };
}
